var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalEnchanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 53,
    viewBox: "0 0 159 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__Canvas",
    transform: "translate(6620 2312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path0_fill",
    transform: "translate(-6620 -2274.38)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path1_fill",
    transform: "translate(-6607.32 -2312)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "local-enchanced_svg__local-enchanced_svg__LOCAL"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path2_fill",
    transform: "translate(-6554.57 -2295.22)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path3_fill",
    transform: "translate(-6554.57 -2295.22)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path4_fill",
    transform: "translate(-6554.57 -2295.22)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path5_fill",
    transform: "translate(-6554.57 -2295.22)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#local-enchanced_svg__local-enchanced_svg__path6_fill",
    transform: "translate(-6554.57 -2295.22)",
    fill: "#3D8CDE",
    fillOpacity: 0.8
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 27.1656 0C 12.1387 0 0 3.43721 0 7.69002C 0 11.9428 12.1816 15.38 27.1656 15.38C 42.1495 15.38 54.3311 11.9428 54.3311 7.69002C 54.3311 3.43721 42.1924 0 27.1656 0ZM 27.1655 10.6615C 13.5684 10.6615 2.54492 8.88464 2.54492 6.68541C 2.54492 4.48618 13.4254 0.480957 27.0225 0.480957C 40.6196 0.480957 51.7861 4.48618 51.7861 6.68541C 51.7861 8.88464 40.7626 10.6178 27.1655 10.6178L 27.1655 10.6615Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 15.4987 0C 6.01932 0 0 8.34543 0 17.0695C 0 25.7936 15.4987 45.1206 15.4987 45.1206C 15.4987 45.1206 30.9973 25.5897 30.9973 16.8656C 30.9973 8.14152 25.1782 0 15.4987 0ZM 15.4985 27.7455C 9.33143 27.7455 4.33203 22.6528 4.33203 16.3707C 4.33203 10.0885 9.33143 4.99585 15.4985 4.99585C 21.6656 4.99585 26.665 10.0885 26.665 16.3707C 26.665 22.6528 21.6656 27.7455 15.4985 27.7455Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path2_fill",
    d: "M 0 19.224L 13.257 19.224L 13.257 16.2L 3.321 16.2L 3.321 0.324L 0 0.324L 0 19.224Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path3_fill",
    d: "M 24.6537 19.548C 30.4587 19.548 34.5627 15.093 34.5627 9.774L 34.5627 9.72C 34.5627 4.401 30.5127 0 24.7077 0C 18.9027 0 14.7987 4.455 14.7987 9.774L 14.7987 9.828C 14.7987 15.147 18.8487 19.548 24.6537 19.548ZM 24.7077 16.47C 20.9547 16.47 18.2817 13.446 18.2817 9.774L 18.2817 9.72C 18.2817 6.048 20.9007 3.051 24.6537 3.051C 28.4067 3.051 31.0797 6.102 31.0797 9.774L 31.0797 9.828C 31.0797 13.5 28.4607 16.47 24.7077 16.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path4_fill",
    d: "M 47.3502 19.548C 50.8872 19.548 53.0472 18.252 55.0182 16.2L 52.8852 14.04C 51.2652 15.552 49.7802 16.47 47.4582 16.47C 43.8402 16.47 41.2212 13.473 41.2212 9.774L 41.2212 9.72C 41.2212 6.021 43.8672 3.051 47.4582 3.051C 49.6182 3.051 51.2382 3.996 52.7502 5.4L 54.8832 2.943C 53.0742 1.215 50.9682 0 47.4852 0C 41.7612 0 37.7382 4.401 37.7382 9.774L 37.7382 9.828C 37.7382 15.255 41.8422 19.548 47.3502 19.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path5_fill",
    d: "M 56.8888 19.224L 60.2908 19.224L 62.2348 14.661L 71.1718 14.661L 73.0888 19.224L 76.5988 19.224L 68.2828 0.189L 65.2048 0.189L 56.8888 19.224ZM 63.4498 11.718L 66.6898 4.158L 69.9568 11.718L 63.4498 11.718Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "local-enchanced_svg__local-enchanced_svg__path6_fill",
    d: "M 79.8398 19.224L 93.0968 19.224L 93.0968 16.2L 83.1608 16.2L 83.1608 0.324L 79.8398 0.324L 79.8398 19.224Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalEnchanced);
export default __webpack_public_path__ + "static/media/local-enchanced.c576a6d0fe6467ee7a98655cc80d2431.svg";
export { ForwardRef as ReactComponent };